export const apiurl = {
  volunteerResources:
    'https://columbus.ifipartners.org/involve/airport-pick-temp-housing/',
};
